import { CommonResponse, ErrorResponse } from "@boi/backend-utils";
import { ChapterReqModel, ClassIdRequestModel, ClassRequestModel, ClassSubjectReq, ClassSubjectReqModel, ClonePaperReq, CreateQuestionPaperReq, DefaultModelPaperCheckReqModel, PaperGenMethodEnum, PaperPreviewModel, PaperPreviewSectionsModel, QNPIdReq, QPaperMergeCreateReqModel, QPaperMergeGerReqModel, QnosReq, QuestionReqModel, QuestionsModel, SetAndQuestionMappingsModel, SubjectClassReqModel, qPRequestModel } from "@boi/shared-models";
import { WhatsAppNotificationService } from "@boi/shared-services";
import { Injectable } from "@nestjs/common";
import ShortUniqueId from 'short-unique-id';
import { DataSource, In } from "typeorm";
import { GenericTransactionManager } from "../../database/typeorm-transactions";
import { TabQuestionRepo } from "../create-questions/repos/tab-question.repo";
import { ModelPaperRepo } from "../model-paper/repositories/model-paper-repo";
import { SectionQuestionsMappingAdapter } from "./dtos/section-questions-mapping.adaptr";
import { UserToQnosMappingEntity } from "./entities/user-to-qnos-mapping.entity";
import { ChapterRepo } from "./repo/chapter-repo";
import { ClassRepo } from "./repo/class-repo";
import { ComplexityRepo } from "./repo/complexity-repo";
import { CreateQuestionRepo } from "./repo/create-question-repo";
import { LanguagesRepo } from "./repo/languages-repo";
import { QuestionPapersRepo } from "./repo/question-papers-repo";
import { QuestionTypeRepo } from "./repo/question-type-repo";
import { SectionWiseModelRepo } from "./repo/section-wise-model-repo";
import { SubjectRepo } from "./repo/subject-repo";
import { TopicRepo } from "./repo/topic-repo";
import { QuestionPaperModal } from "../model-paper/entities/question-paper-modal";
import { PaperMergeRepo } from "./repo/paper-merge.repo";
import { PaperMergeChildRepo } from "./repo/paper-merge-child.repo";
import { PaperMergeEntity } from "./entities/paper-merge.entity";
import { PaperMergeChildEntity } from "./entities/paper-merge-child.entity";


@Injectable()
export class AiGeneratedQpService {
    constructor(
        private dataSource: DataSource,
        private classRepo: ClassRepo,
        private subjectRepo: SubjectRepo,
        private chapterRepo: ChapterRepo,
        private topicRepo: TopicRepo,
        private complexityRepo: ComplexityRepo,
        private languagesRepo: LanguagesRepo,
        private questionType: QuestionTypeRepo,
        private createQuestionRepo: CreateQuestionRepo,
        private modelPaperRepo: ModelPaperRepo,
        private questionPapersRepo: QuestionPapersRepo,
        private sectionWiseModelRepo: SectionWiseModelRepo,
        private adapter: SectionQuestionsMappingAdapter,
        private wtsAppMessage: WhatsAppNotificationService,
        private tabQuestionRepo: TabQuestionRepo,
        private paperMergeRepo: PaperMergeRepo,
        private paperMergeChildRepo: PaperMergeChildRepo,
    ) { }

    async getAllClasses(): Promise<CommonResponse> {
        const result = await this.classRepo.getAllClasses();
        return new CommonResponse(true, 123, 'classes retrieved successfully', result);
    }

    async getLanguagesByClassSubject(req: ClassSubjectReq): Promise<CommonResponse> {
        const subjectName = await this.subjectRepo.findOne({ select: ['id', 'subject'], where: { id: req.subject } });
        const result = await this.subjectRepo.getLanguagesByClassSubject(subjectName.subject, req.classId);
        return new CommonResponse(true, result.length, 'Subjects and Languages retrieved successfully', result);
    }

    async getAllLanguages(): Promise<CommonResponse> {
        const result = await this.languagesRepo.getAllLanguages();
        return new CommonResponse(true, 123, 'Languages retrieved successfully', result);
    }

    async getSubjectsByClass(req: ClassRequestModel): Promise<CommonResponse> {
        const result = await this.subjectRepo.getSubjectsByClass(req);
        return new CommonResponse(true, 123, 'Subjects retrieved successfully', result);
    }

    async getChaptersBySubject(req: SubjectClassReqModel): Promise<CommonResponse> {
        const result = await this.chapterRepo.getChaptersBySubject(req);
        return new CommonResponse(true, 123, 'Chapters retrieved Successfully', result)
    }

    async getDistinctSubjects(className?: string): Promise<CommonResponse> {
        const result = await this.tabQuestionRepo.getDistinctSubjects(className);
        return new CommonResponse(true, 123, 'Subjects retrieved successfully', result);
    }

    async getSubjectByClass(classId?: number): Promise<CommonResponse> {
        const result = await this.subjectRepo.getSubjectByClass(classId);
        return new CommonResponse(true, 123, 'Subjects retrieved successfully', result);
    }

    // async getSubjectByClass(classId?: number): Promise<CommonResponse> {
    //     console.log('Received classId:', classId);

    //     const result = await this.subjectRepo.getSubjectByClass(classId);
    //     console.log('Query result:', result);

    //     return new CommonResponse(true, 123, 'Subjects retrieved successfully', result);
    // }

    async getDistinctChapters(className?: string): Promise<CommonResponse> {
        const result = await this.tabQuestionRepo.getDistinctChapters(className);
        return new CommonResponse(true, 123, 'Chapters retrieved successfully', result);
    }

    async getChaptersBySubjectAndClass(req: SubjectClassReqModel): Promise<CommonResponse> {
        const result = await this.chapterRepo.getChaptersBySubjectAndClass(req);
        return new CommonResponse(true, 123, 'Chapters retrieved successfully', result);
    }

    async getDistinctMarks(className?: string): Promise<CommonResponse> {
        const result = await this.tabQuestionRepo.getDistinctMarks(className);
        return new CommonResponse(true, 123, 'Marks retrieved successfully', result);
    }


    async getDistinctMarksFromCreateQuestions(req: ChapterReqModel): Promise<CommonResponse> {
        const result = await this.createQuestionRepo.getDistinctMarksFromCreateQuestions(req);
        return new CommonResponse(true, 123, 'Marks retrieved successfully', result);
    }

    async getMarksByClass(classId?: number): Promise<CommonResponse> {
        const result = await this.createQuestionRepo.getMarksByClass(classId);
        return new CommonResponse(true, 123, 'Marks retrieved successfully', result);
    }

    async getChaptersByClassAndSubject(req: ClassSubjectReqModel): Promise<CommonResponse> {
        const result = await this.tabQuestionRepo.getChaptersByClassAndSubject(req);
        return new CommonResponse(true, 123, 'Chapters retrieved successfully', result);
    }


    async getTopicsByChapter(req: ChapterReqModel): Promise<CommonResponse> {
        const result = await this.topicRepo.getTopicsByChapter(req.chapter);
        return new CommonResponse(true, 123, 'Chapters retrieved Successfully', result)
    }

    async getMarksByChapter(req: ChapterReqModel): Promise<CommonResponse> {
        const result = await this.createQuestionRepo.getMarksByChapter(req);
        return new CommonResponse(true, 123, 'Chapters retrieved Successfully', result)
    }

    async getAllDifficultyLevels(): Promise<CommonResponse> {
        const result = await this.complexityRepo.find({ select: ['id', 'complexity'] });
        return new CommonResponse(true, 123, 'Difficulty levels retrieved Successfully', result)
    }

    async getAllQuestionTypes(): Promise<CommonResponse> {
        const result = await this.questionType.find({ select: ['id', 'questiontype'] });
        return new CommonResponse(true, 123, 'All Question Types retrieved Successfully', result)
    }

    async getAllQuestions(req: QuestionReqModel, select = []): Promise<CommonResponse> {
        const where = {
            class: req.className,
            subject: req.subject,
            chapter: req.chapter,
            isActive: true
        }

        if (req.topic) {
            where['topic'] = req.topic
        }

        if (req.difficultyLevel) {
            where['complexity'] = req.difficultyLevel
        }

        if (req.questionType) {
            where['qtype'] = req.questionType
        }


        if (req.weightage) {
            where['marks'] = req.weightage
        }

        const result = await this.createQuestionRepo.find({
            select,
            where
        });
        return new CommonResponse(true, 123, 'All Questions retrieved Successfully', result)
    }

    async getAllQuestionsCount(req: QuestionReqModel): Promise<CommonResponse> {
        const where = {
            class: req.className,
            subject: req.subject,
            chapter: req.chapter,
            isActive: true
        }
        if (req.topic) {
            where['topic'] = req.topic
        }
        if (req.difficultyLevel) {
            where['complexity'] = req.difficultyLevel
        }
        if (req.questionType) {
            where['qtype'] = req.questionType
        }


        if (req.weightage) {
            where['marks'] = req.weightage
        }
        const result = await this.createQuestionRepo.count({
            where
        });

        return new CommonResponse(true, 1234, 'All Questions retrieved Successfully', result)
    }

    shuffleArray = (array) => {
        const shuffledArray = [...array];
        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
        }
        return shuffledArray;
    };

    async createQuestionPaper(req: CreateQuestionPaperReq): Promise<CommonResponse> {
        const transactionalEntityManager = new GenericTransactionManager(this.dataSource);
        try {
            const entitiesToSave = [];
            const { randomUUID } = new ShortUniqueId({ length: 10 });
            const paperBundlerId = randomUUID(20);
            for (const set of Array.from({ length: req.noOfSets }, (_, index) => index + 1)) {
                const questionAndSerialNumbersMap = new Map();
                const sets = req.generationMethod === PaperGenMethodEnum.SYSTEM ? this.adapter.getSectionMappingsOfSection(req.sectionQuestionMappings, 1) : this.adapter.getSectionMappingsOfSection(req.sectionQuestionMappings, set);
                for (const sections of sets.sectionsMapping) {
                    if (req.generationMethod === PaperGenMethodEnum.SYSTEM) {
                        const questions = await this.getAllQuestions(sections, ['qno']);
                        const questionsIds = this.shuffleArray(questions.data.map(rec => rec.qno));
                        const result = new Set<number>();
                        while (result.size < sections.noOfQns) {
                            const randomInt = Math.floor(Math.random() * (questionsIds.length - 0 + 1)) + 0;
                            if (questionsIds[randomInt]) {
                                if (!result.has(questionsIds[randomInt]) && !questionAndSerialNumbersMap.has(questionsIds[randomInt])) {
                                    result.add(questionsIds[randomInt]);
                                    questionAndSerialNumbersMap.set(questionsIds[randomInt], { serialQno: questionAndSerialNumbersMap.size, qno: questionsIds[randomInt] });
                                }
                            }
                        }
                        sections.qnos = Array.from(result).toString();
                    } else {
                        const qnos = sections.qnos.split(',');
                        qnos.forEach((qno) => {
                            if (!questionAndSerialNumbersMap.has(qno)) {
                                questionAndSerialNumbersMap.set(qno, { serialQno: questionAndSerialNumbersMap.size, qno: Number(qno) });
                            }
                        })
                    }
                }
                req.noOfSets = set;
                req.paperBundlerId = paperBundlerId;
                const entity = this.adapter.convertDtoToEntity(req, Array.from(questionAndSerialNumbersMap.values()));
                entitiesToSave.push(entity);
                if (req.generateOtherLanguagePapers) {
                    const subjectName = await this.subjectRepo.findOne({ select: ['id', 'subject', 'class'], where: { id: req.subject } });
                    const result = await this.subjectRepo.getOtherLanguageSubjectIds(subjectName.subject, subjectName.class, req.subject);
                    const mainModelPaperIdData = await this.modelPaperRepo.findOne({ where: { id: req.qnpModelId } });
                    console.log(mainModelPaperIdData, 'mainModelPaperIdData');

                    for (const otherSubject of result) {
                        const allQnosSet = new Set();
                        console.log(otherSubject, 'otherSubject');
                        const otherModel = await this.modelPaperRepo.findOne({ where: { class: subjectName.class, subject: otherSubject.subjectId, language: otherSubject.languageId, mainModelPaperId: mainModelPaperIdData.mainModelPaperId } });
                        console.log(otherModel, 'otherModel');

                        const otherSubReq: CreateQuestionPaperReq = JSON.parse(JSON.stringify(req));
                        otherSubReq.subject = otherSubject.subjectId;
                        otherSubReq.qnpModelId = otherModel.id;
                        console.log(otherSubReq, 'otherSubReq');
                        console.log(req);
                        const sectionMappings = [...sets.sectionsMapping];
                        for (const sec of sectionMappings) {
                            const mainQnpModel = new QuestionPaperModal();
                            mainQnpModel.id = req.qnpModelId;
                            const mainSection = await this.sectionWiseModelRepo.findOne({ where: { id: sec.sectionId } });
                            const sectionId = await this.sectionWiseModelRepo.findOne({ where: { qnpModel: otherModel, eachQnWeightage: sec.weightage, sectionNo: mainSection.sectionNo } });
                            const qnoArray = sec.qnos.split(',');
                            const result = await this.createQuestionRepo.find({ where: { qno: In([null, ...qnoArray]), subject: otherSubject.subjectId } });
                            if (result.length === qnoArray.length) {
                                sec.chapter = result[0].chapter;
                                sec.className = result[0].class;
                                sec.sectionId = sectionId.id;
                                sec.subject = otherSubject.subjectId;
                                sec.language = otherSubject.languageId;
                                allQnosSet.add(result.length === qnoArray.length);
                            }
                        }
                        otherSubReq.sectionQuestionMappings = [new SetAndQuestionMappingsModel(1, sectionMappings)];
                        if (allQnosSet.size === 1 && allQnosSet.has(true)) {
                            const entity = this.adapter.convertDtoToEntity(otherSubReq, Array.from(questionAndSerialNumbersMap.values()));
                            entitiesToSave.push(entity);
                        }
                    }
                }
            }
            const savedEntity = await this.questionPapersRepo.save(entitiesToSave);
            return new CommonResponse(true, 1234, 'Paper Generated Successfully', savedEntity);
        } catch (err) {
            transactionalEntityManager ? await transactionalEntityManager.releaseTransaction() : '';
            throw err;
        }
    }

    async getAllQuestionPapers(req: qPRequestModel): Promise<CommonResponse> {
        const savedEntities = await this.questionPapersRepo.getAllQuestionPapers(req);
        return new CommonResponse(true, 123, 'All Questions retrieved Successfully', savedEntities)
    }

    async getAllQuestionPapersToMerge(req: QPaperMergeGerReqModel): Promise<CommonResponse> {
        const mainModelPaperIdData = await this.modelPaperRepo.find({ where: { subject: In([...req.subjectIds]) } });
        console.log(mainModelPaperIdData);

        const mainModelPaperIds = Array.from(new Set(mainModelPaperIdData.map(item => item.mainModelPaperId).filter(rec => rec !== null)))
        if (mainModelPaperIds.length === 0) throw new ErrorResponse(123, 'No Papers found to retrieved');
        const savedEntities = await this.questionPapersRepo.getAllQuestionPapersToMerge(req, mainModelPaperIds);
        return new CommonResponse(true, 123, 'All Questions retrieved Successfully', savedEntities)
    }

    async getAllQuestionsByIds(req: QnosReq): Promise<CommonResponse> {
        const result = await this.createQuestionRepo.find({ where: { id: In([null, ...req.qnos]) } });
        return new CommonResponse(true, 123, 'All Questions retrieved Successfully', result)
    }

    async getQuestionPaperDataById(req: QNPIdReq): Promise<CommonResponse> {
        const sectionWiseMap: Map<number, Map<number, number[]>> = new Map();
        const sectionDataMap: Map<number, { mandatory_qns: number, each_qn_weightage: number, section_marks: number, note: string }> = new Map();
        const data = await this.questionPapersRepo.getQuestionPaperDataById(req);
        for (const sectionLevelData of data) {
            if (!sectionWiseMap.has(sectionLevelData.section))
                sectionWiseMap.set(sectionLevelData.section, new Map());
            if (!sectionWiseMap.get(sectionLevelData.section).has(sectionLevelData.chapter))
                sectionWiseMap.get(sectionLevelData.section).set(sectionLevelData.chapter, sectionLevelData.qno_s?.split(','));
            else {
                sectionWiseMap.get(sectionLevelData.section).get(sectionLevelData.chapter).push(...sectionLevelData.qno_s?.split(','));
            }
            sectionDataMap.set(sectionLevelData.section, {
                mandatory_qns: sectionLevelData.mandatory_qns,
                each_qn_weightage: sectionLevelData.each_qn_weightage,
                section_marks: sectionLevelData.section_marks,
                note: sectionLevelData.note
            });
        }
        if (sectionWiseMap.size) {
            const res = new PaperPreviewModel(data[0].class_name, data[0].subject_name, data[0].no_of_sections, data[0].marks, data[0].total_questions, data[0].time_limit, data[0].tagline, data[0].setno, data[0].language_name, data[0].instructions, [], data[0].qnos_order ? JSON.parse(data[0].qnos_order) : []);
            for (const [section, sectionChapterMap] of sectionWiseMap.entries()) {
                const sectionData = sectionDataMap.get(section);
                const sectionsData = new PaperPreviewSectionsModel(sectionData.mandatory_qns, sectionData.each_qn_weightage, sectionData.section_marks, sectionData.note, []);
                for (const [chapter, qnos] of sectionChapterMap.entries()) {
                    // const result = (await this.createQuestionRepo.find({ select: ['qno', 'question'], where: { qno: In([null, Array.from(new Set(qnos))]), subject: data[0].subject, class: data[0].class, chapter: chapter } })).map(rec => new QuestionsModel(rec.qno, rec.question));
                    const fetchedQuestions = await this.createQuestionRepo.find({
                        select: ['qno', 'question'],
                        where: { qno: In([null, ...Array.from(new Set(qnos))]), subject: data[0].subject, class: data[0].class, chapter: chapter }
                    });

                    // preserve the exact order from qnos array
                    const orderedQuestions = qnos
                        .map(qno => fetchedQuestions.find(q => q.qno === Number(qno)))
                        .filter(Boolean) // remove nulls
                        .map(rec => new QuestionsModel(rec.qno, rec.question));
                    sectionsData.questions.push(...orderedQuestions)
                }
                res.sections.push(sectionsData);
            }
            return new CommonResponse(true, 1235, 'All Questions retrieved Successfully', res)
        } else {
            return new CommonResponse(false, 1235, 'All Questions retrieved Successfully')
        }
    }

    async isDefaultModelPaperExist(req: DefaultModelPaperCheckReqModel) {
        const subjectName = await this.subjectRepo.findOne({ select: ['id', 'subject'], where: { id: req.subjectId } });
        const result = await this.subjectRepo.getOtherLanguageSubjectIds(subjectName.subject, req.classId, req.subjectId);
        const languages = []
        const modelPaperData = await this.modelPaperRepo.findOne({ where: { mainModelPaperId: req.mainModelPaperId } })
        for (const subjectLanguage of result) {
            const count = await this.modelPaperRepo.count({ where: { class: req.classId, subject: subjectLanguage.subjectId, language: subjectLanguage.languageId, mainModelPaperId: modelPaperData.mainModelPaperId } });
            if (!count) {
                languages.push(subjectLanguage.language)
            }
        }
        if (languages.length) {
            throw new ErrorResponse(123, `Languages ${languages.toString()} doesn't have default modal`);
        } else {
            return new CommonResponse(true, 1234, 'Languages have default modal');
        }
    }
    async clonePaperToOtherLanguage(req: ClonePaperReq) {

        return new CommonResponse(false, 1235, 'Paper Cloned Successfully');
    }


    async validateOtp(req: QNPIdReq): Promise<CommonResponse> {
        const data = await this.questionPapersRepo.findOne({ select: ['otp'], where: { id: req.qnpId } });
        return new CommonResponse(false, 1235, 'All Questions retrieved Successfully');
    }

    generateOTP() {
        const otpLength = 9;
        const minDigit = 0;
        const maxDigit = 9;
        let otp = '';
        for (let i = 0; i < otpLength; i++) {
            const randomDigit = Math.floor(Math.random() * (maxDigit - minDigit + 1)) + minDigit;
            otp += randomDigit.toString();
        }
        return otp;
    }


    async generateOtp(req: QNPIdReq): Promise<CommonResponse> {
        //     const otp = this.generateOTP();

        //     const currentDate = new Date();
        //     const formattedDate = currentDate.toLocaleString();

        //     const data = await this.questionPapersRepo.update({ id: req.qnpId }, { otp });

        //     const mobileNums = ['7013647957'];
        //     const messageStatuses = [];

        //     const otpTemplate = `
        // 📅 ${formattedDate}
        // 🔐 Your One-Time Password (OTP) is: ${otp} 🔑
        // ⏳ This OTP is valid for 5 minutes. ⏳
        // ❗️ Do not share your OTP with anyone. ❗️
        // 🚫 If you did not request this OTP, please contact customer support. 🚫
        //     `;

        //     for (const contact of mobileNums) {
        //         const parameters = [
        //             { name: 'otp', value: otpTemplate },
        //         ];
        //         const req = await new MessageParameters(contact, otpTemplate, parameters, 'en_us');

        //         const messageStatus = await this.wtsAppMessage.sendMessageThroughFbApi(req);
        //         if (messageStatus.status) {
        //             messageStatuses.push(messageStatus);
        //         }
        //     }

        return new CommonResponse(true, 11108, 'OTP generated successfully');
    }

    async getSubjectsByClassId(req: ClassRequestModel): Promise<CommonResponse> {
        const result = await this.subjectRepo.getSubjectsByClassId(req);
        return new CommonResponse(true, 124, 'Subjects retrieved successfully', result);
    }

    async getBaseSubjectsDropDown(req: ClassRequestModel): Promise<CommonResponse> {
        const result = await this.subjectRepo.getBaseSubjectsDropDown(req);
        console.log(result, 'result');

        return new CommonResponse(true, 124, 'Subjects retrieved successfully', result);
    }

    async getOtherLanguageSubjects(req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            const subjectName = await this.subjectRepo.findOne({
                select: ['id', 'subject', 'class', 'language'],
                where: { id: req.subject },
            });
            const result = await this.subjectRepo.getOtherLanguageSubjectIds(subjectName.subject, subjectName.class, req.subject);
            return new CommonResponse(true, 1234, 'Other language Subjects Retrieved Successfully', result);
        } catch (err) {
            throw err;
        }
    }

    async getAllSubjectIdsForPreview(req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            const subjectName = await this.subjectRepo.findOne({
                select: ['id', 'subject', 'class', 'language'],
                where: { id: req.subject },
            });
            const result = await this.subjectRepo.getAllSubjectIdsForPreview(subjectName.subject, subjectName.class, req.subject);
            return new CommonResponse(true, 1234, 'Other language Subjects Retrieved Successfully', result);
        } catch (err) {
            throw err;
        }
    }

    async getOtherLanguageQuestions(req: CreateQuestionPaperReq): Promise<CommonResponse> {
        try {
            const subjectName = await this.subjectRepo.findOne({
                select: ['id', 'subject', 'class'],
                where: { id: req.subject },
            });

            const questionAndSerialNumbersMap = new Map();
            const sets = this.adapter.getSectionMappingsOfSection(req.sectionQuestionMappings, 1);
            let sectionWiseMap = new Map();
            for (const sections of sets.sectionsMapping) {
                const qnos = sections.qnos.split(',');
                qnos.forEach((qno) => {
                    if (!questionAndSerialNumbersMap.has(qno)) {
                        questionAndSerialNumbersMap.set(qno, { serialQno: questionAndSerialNumbersMap.size, qno: Number(qno) });
                    }
                });
                if (!sectionWiseMap.has(sections.sectionId))
                    sectionWiseMap.set(sections.sectionId, { ...sections, sectionWiseQuestions: sections.qnos?.split(',') });
                else {
                    sectionWiseMap.get(sections.sectionId).sectionWiseQuestions.push(...sections.qnos?.split(','));
                }
            }
            sectionWiseMap = new Map(
                [...sectionWiseMap.entries()].sort((a, b) => a[0] - b[0])
            );

            const result = await this.subjectRepo.getAllSubjectIdsForPreview(subjectName.subject, subjectName.class, req.subject);
            const questions = [];
            const qnpModelData = await this.modelPaperRepo.findOne({ where: { id: req.qnpModelId } });
            for (const otherSubject of result) {
                const allQnosSet = new Set();
                const otherModel = await this.modelPaperRepo.findOne({ where: { class: subjectName.class, subject: otherSubject.subjectId, language: otherSubject.languageId, mainModelPaperId: qnpModelData.mainModelPaperId } });
                const otherSubReq: CreateQuestionPaperReq = JSON.parse(JSON.stringify(req));
                otherSubReq.subject = otherSubject.subjectId;
                otherSubReq.qnpModelId = otherModel.id;
                const className = await this.classRepo.findOne({ where: { id: subjectName.class } });
                const subjectNames = await this.subjectRepo.findOne({ where: { id: otherSubject.subjectId } });
                const languageName = await this.languagesRepo.findOne({ where: { id: otherSubject.languageId } });

                const res = new PaperPreviewModel(className.class, subjectNames.subject, otherModel.noOfSections, otherModel.marks, otherModel.totalQuestions, otherModel.timeLimit, otherModel.tagline, '1', languageName.language, otherModel.instructions, [], Array.from(questionAndSerialNumbersMap.values()));

                for (const [section, sectionData] of sectionWiseMap.entries()) {
                    const mainSection = await this.sectionWiseModelRepo.findOne({ where: { id: section } });
                    const sectionId = await this.sectionWiseModelRepo.findOne({ where: { qnpModel: otherModel, eachQnWeightage: mainSection.eachQnWeightage, sectionNo: mainSection.sectionNo } });
                    // const result = (await this.createQuestionRepo.find({ select: ['qno', 'question'], where: { qno: In([null, ...sectionData.sectionWiseQuestions]), subject: otherSubject.subjectId, class: subjectName.class } })).map(rec => new QuestionsModel(rec.qno, rec.question));
                    // const sectionsData = new PaperPreviewSectionsModel(sectionId.mandatoryQns, sectionId.eachQnWeightage, sectionId.marks, sectionId.note, result);
                    const fetchedQuestions = await this.createQuestionRepo.find({ select: ['qno', 'question', 'chapter'], where: { qno: In([null, ...sectionData.sectionWiseQuestions]), subject: otherSubject.subjectId, class: subjectName.class } });
                    // const orderedQuestions = sectionData.sectionWiseQuestions.map(qno => { return fetchedQuestions.find(q => q.qno === Number(qno));}).filter(Boolean).map(rec => new QuestionsModel(rec.qno, rec.question));
                    const orderedQuestions = sectionData.sectionWiseQuestions
                        .map(qno => fetchedQuestions.find(q => q.qno === Number(qno)))
                        .filter(Boolean)
                        .sort((a, b) => {
                            if (a.chapter === b.chapter) {
                                // same chapter → preserve order of selection
                                return sectionData.sectionWiseQuestions.indexOf(a.qno.toString()) -
                                    sectionData.sectionWiseQuestions.indexOf(b.qno.toString());
                            }
                            // different chapters → keep natural selection order
                            return sectionData.sectionWiseQuestions.indexOf(a.qno.toString()) -
                                sectionData.sectionWiseQuestions.indexOf(b.qno.toString());
                        })
                        .map(rec => new QuestionsModel(rec.qno, rec.question));
                    const sectionsData = new PaperPreviewSectionsModel( sectionId.mandatoryQns, sectionId.eachQnWeightage, sectionId.marks, sectionId.note, orderedQuestions);
                    res.sections.push(sectionsData);
                }
                questions.push(res);
            }
            return new CommonResponse(true, 1234, 'Other language Questions Retrieved Successfully', questions);
        } catch (err) {
            throw err;
        }
    }

    async userQnoMapInsert() {
        const users = ['biesecretary@bie.com', 'biecto@bie.com', 'bieap_user2@bie.com', 'bieap_user1@bie.com', 'bieap_user3@bie.com'];
        for (const user of users) {
            const questions = await this.createQuestionRepo.find({ select: ['id'] })
            const questionsIds = this.shuffleArray(questions.map(rec => rec.id));
            const result = new Set<number>();
            while (result.size != questions.length) {
                const randomInt = Math.floor(Math.random() * (questionsIds.length - 0 + 1)) + 0;
                if (questionsIds[randomInt]) {
                    if (!result.has(questionsIds[randomInt])) {
                        result.add(questionsIds[randomInt]);
                    }
                }
            }
            const entitiesArray = [];
            for (const qno of Array.from(result)) {
                const entity = new UserToQnosMappingEntity();
                entitiesArray.push(entity)
            }

        }

    }




    async savePaperMergeData(req: QPaperMergeCreateReqModel): Promise<CommonResponse> {
        const paperMerge = new PaperMergeEntity();
        paperMerge.id = req.id;
        paperMerge.noOfParts = req.noOfParts;
        paperMerge.paperName = req.paperName;
        paperMerge.classId = req.classId;
        const paperMergeChildData = []
        for (const part of req.paperMergeChild) {
            const paperMergeChild = new PaperMergeChildEntity();
            paperMergeChild.paperId = part.paperId;
            paperMergeChild.partId = part.partId;
            paperMergeChild.paperMergeId = paperMerge;
            paperMergeChild.mainModelPaperId = part.mainModelPaperId;
            paperMergeChildData.push(paperMergeChild);
        }
        paperMerge.paperMergeChild = paperMergeChildData;
        await this.paperMergeRepo.save(paperMerge);
        return new CommonResponse(true, 1234, 'Paper Merge Created Successfully');
    }

    async getAllPaperMergeData(req: ClassIdRequestModel): Promise<CommonResponse> {
        try {

            const result = await this.paperMergeRepo.getMergeData(req);

            const paperIdsMap = new Map<number, Map<string, Map<number, any>>>();
            const mergeMap = new Map<number, any>()
            const paperIds = new Map<number, Set<number>>();
            for (const merge of result) {
                for (const child of merge.paperMergeChild) {
                    const data = await this.questionPapersRepo.getAllQuestionPapersOfGivenBundlePaperId(req.classId, child.paperId);
                    for (const dataItem of data) {
                        if (!paperIdsMap.has(merge.id)) {
                            paperIdsMap.set(merge.id, new Map<string, Map<number, any>>());
                        }
                        if (!paperIdsMap.get(merge.id).has(dataItem.language)) {
                            paperIdsMap.get(merge.id).set(dataItem.language, new Map<number, any>());
                        }
                        paperIdsMap.get(merge.id).get(dataItem.language).set(child.paperId, { ...dataItem, paperMergeId: merge.id, paperName: merge.paperName, noOfParts: merge.noOfParts });
                        if (!paperIds.has(merge.id)) {
                            paperIds.set(merge.id, new Set<number>())
                        }
                        paperIds.get(merge.id).add(child.paperId)
                    }
                    if (!mergeMap.has(merge.id)) {
                        const mergeClone = { ...merge };
                        delete mergeClone.paperMergeChild
                        mergeMap.set(merge.id, merge)
                    }
                }
            }
            console.log(paperIdsMap, 'paperIdsMap');
            console.log(mergeMap, 'mergeMap');


            const languageWiseGroupData = []
            for (const [merge, mergeData] of mergeMap.entries()) {
                const paperData = { ...mergeData };
                delete paperData.paperMergeChild
                paperData['languageWiseData'] = [];
                for (const [language, paperIdMap] of paperIdsMap.get(merge)) {
                    const languageWiseData = {
                        language: language,
                        data: []
                    }
                    for (const paperId of Array.from(paperIds.get(merge))) {
                        languageWiseData.data.push(paperIdMap.get(paperId))
                    }
                    paperData['languageWiseData'].push(languageWiseData);
                }
                languageWiseGroupData.push(paperData);
            }


            return new CommonResponse(true, 1234, 'Paper Merge Data Fetched Successfully', languageWiseGroupData);
        } catch (error) {
            console.log(error);

            throw error
        }
    }

    async getDistinctSubjectsForLogin(): Promise<CommonResponse> {
        const result = await this.subjectRepo.getDistinctSubjectsRepo();
        return new CommonResponse(true, 123, 'Languages retrieved successfully', result);
    }
}